// Pagination.js

import {
    defineComponent,
    computed,
    inject,
    watch,
    toRefs
} from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "Pagination",
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    setup(props, { emit }) {
        const maxCount = inject("maxCount");
        const nowPage = inject("nowPage");
        //const allProductData = inject("allProductData");
        const { data } = toRefs(props);
        const totalPage = computed(() => {
            return Math.ceil(
                data.value.length / maxCount.value
            );
        });
        const pageButtons = computed(() => {
            const current = nowPage.value;
            const total = totalPage.value;
            const pages = [];

            // 固定第一頁
            pages.push(1);

            if (current <= 3) {
                // 當前在前段
                for (let i = 2; i <= Math.min(4, total - 1); i++) {
                    pages.push(i);
                }
                if (total > 5) pages.push("...");
            } else if (current >= total - 2) {
                // 當前在後段
                pages.push("...");
                for (let i = total - 3; i < total; i++) {
                    if (i > 1) pages.push(i);
                }
            } else {
                // 當前在中段
                pages.push("...");
                pages.push(current - 1);
                pages.push(current);
                pages.push(current + 1);
                pages.push("...");
            }

            // 固定最後一頁（但避免重複）
            if (total > 1) pages.push(total);

            return pages;
        });
        watch(maxCount, () => {
            nowPage.value = 1;
        });

        return { maxCount, nowPage, totalPage, pageButtons };
    },

    template: html`
        <div class="pagination_nav" v-show="data.length>0">
            <div class="pagination_nav_region">
                <div class="count">
                    一頁顯示：
                    <select class="count_select" v-model.number="maxCount">
                        <option value="10">10筆</option>
                        <option value="20">20筆</option>
                        <option value="40">40筆</option>
                    </select>
                </div>
                <div class="pagination">
                    <button
                        class="pagination_arrow pagination_arrow_left"
                        @click="nowPage > 1 && nowPage--"
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="23"
                                height="23"
                                rx="11.5"
                                stroke="#A99F96"
                            ></rect>
                            <path
                                d="M14.5 7L7.90031 12.1855C7.69648 12.3456 7.69648 12.6544 7.90031 12.8145L14.5 18"
                                stroke="#A99F96"
                                stroke-width="1.2"
                                stroke-linecap="round"
                            ></path>
                        </svg>
                    </button>
                    <template v-for="(p, index) in pageButtons" :key="index">
                        <button
                            v-if="typeof p === 'number'"
                            class="pagination_number"
                            :disabled="p === nowPage"
                            @click="nowPage = p"
                        >
                            {{ p }}
                        </button>
                        <span v-else class="pagination_ellipsis">...</span>
                    </template>
                    <button
                        class="pagination_arrow pagination_arrow_right"
                        @click="nowPage < totalPage && nowPage++"
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="23"
                                height="23"
                                rx="11.5"
                                stroke="#A99F96"
                            ></rect>
                            <path
                                d="M14.5 7L7.90031 12.1855C7.69648 12.3456 7.69648 12.6544 7.90031 12.8145L14.5 18"
                                stroke="#A99F96"
                                stroke-width="1.2"
                                stroke-linecap="round"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    `,
    methods: {},
});
